const defaultRight = "right";

const transition = {
  // Which transition animation to perform?
  DEFAULT: defaultRight,
  LEFT: "left",
  RIGHT: defaultRight,
  UP: "up",
  DOWN: "down",
  FADE: "fade",
  NONE: "none",

  // Are we moving forward or backward?
  FORWARD: "forward",
  BACKWARD: "backward"
};

export const DIRECTIVE_TRANSITIONS = [transition.LEFT, transition.RIGHT, transition.UP, transition.DOWN];

export default transition;
